<template>
  <v-col>
		<div class="py-1 d-flex font-size-13 grey--text">
      <v-btn class="rounded-xl" depressed color="grey lighten-1" @click="goBack">
        <v-icon small>mdi-arrow-left</v-icon>
        <div class="pl-1 text-capitalize">Kembali</div>
      </v-btn>
      <div class="pl-3 font-size-11 grey--text text--darken-2 font-weight-bold my-auto" v-if="!loading">Detail Transaksi {{ transactionDetail.transaction_code }}</div>
		</div>
    <div class="mt-5">
      <div class="d-flex flex-wrap" v-if="!loading">
        <v-col cols="12" md="12" class="px-0py-0">
          <v-row>
            <v-col cols="12 pb-0">
              <v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
                <div class="d-flex flex-wrap">
                  <v-col cols="12" sm="4" md="4" class="py-0 font-size-10">
                    <div class="cl-grey font-weight-bold">Tanggal</div>
                    <div class="cl-dark-green">{{ transactionDetail.transaction_datetime | tanggaljam }}</div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" class="pb-0 py-sm-0 font-size-10">
                    <template v-if="transactionDetail.transaction_status == '5'">
                      <div class="cl-grey font-weight-bold">No Resi</div>
                      <div class="cl-dark-green">{{ transactionDetail.transaction_receipt_number ? transactionDetail.transaction_receipt_number : '-' }}</div>
                    </template>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" class="pb-0 py-sm-0 font-size-10 text-md-right my-auto">
                    <div class="cl-grey font-weight-bold">Status</div>
                    <div class="text-capitalize">
                      <v-chip small :color="transactionDetail.transaction_status | toColorStatus" class="font-weight-bold white--text text-uppercase">{{ transactionDetail.transaction_status_formatted }}</v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="pb-0 font-size-10">
                    <template v-if="transactionDetail.transaction_notes">
                      <div class="cl-grey font-weight-bold">Catatan</div>
                      <div class="cl-dark-green">{{ transactionDetail.transaction_notes }}</div>
                    </template>
                  </v-col>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mt-5 py-0">
              <div class="px-3 d-none d-sm-flex flex-wrap">
                <v-col sm="2" md="1" class="py-0"></v-col>
                <v-col sm="3" md="5" class="pl-md-5 py-0">
                  <div class="font-size-10 font-weight-bold">Item</div>
                </v-col>
                <v-col sm="2" md="2" class="py-0 text-center">
                  <div class="font-size-10 font-weight-bold">Qty</div>
                </v-col>
                <v-col sm="2" md="2" class="py-0 text-center">
                  <div class="font-size-10 font-weight-bold">Berat</div>
                </v-col>
                <v-col sm="3" md="2" class="py-0 text-right">
                  <div class="font-size-10 font-weight-bold">Total</div>
                </v-col>
              </div>
              <v-card class="mt-2 pa-3 elevation-0 rounded-xl hover-shadow" v-for="(product, idp) in transactionDetail.transaction_detail" :key="idp">
                <div class="d-flex flex-wrap">
                  <v-col cols="3" sm="2" md="1" class="py-0 px-0 my-auto">
                    <v-img contain width="45px" height="45px" class="mx-auto rounded-xl" :src="product.transaction_detail_product_image ? product.transaction_detail_product_image : '/assets/image/user-pict.jpg'"></v-img>
                  </v-col>
                  <v-col cols="9" sm="3" md="5" class="pl-md-5 py-0 my-auto">
                    <div class="cl-dark-green font-size-10">{{ product.transaction_detail_product_name }}</div>
                    <div class="cl-dark-green font-size-10">
                      {{ parseInt(product.transaction_detail_unit_price) | toRupiah }}
                    </div>
                    <div class="cl-grey font-size-10">{{ product.transaction_detail_product_weight | toKg }}</div>
                  </v-col>
                  <v-col cols="3" sm="2" md="2" class="pb-0 py-sm-0 my-auto text-center">
                    <div class="cl-dark-green font-size-10 font-weight-bold">
                      <span class="font-weight-bold d-sm-none">x</span>
                      <span>{{ parseInt(product.transaction_detail_qty) }}</span>
                    </div>
                  </v-col>
                  <v-col cols="3" sm="2" md="2" class="pb-0 py-sm-0 my-auto text-center">
                    <div class="cl-dark-green font-size-10 font-weight-bold">{{ (product.transaction_detail_product_weight * product.transaction_detail_qty) | toKg }}</div>
                  </v-col>
                  <v-col cols="6" sm="3" md="2" class="pb-0 py-sm-0 my-auto text-right">
                    <div class="cl-dark-green font-size-10 font-weight-bold">{{ ((parseInt(product.transaction_detail_unit_price)) * product.transaction_detail_qty) | toRupiah }}</div>
                  </v-col>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="my-5 py-0">
              <v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
                <div class="px-3 d-flex">
                  <v-icon class="cl-primary">mdi-database-outline</v-icon>
                  <div class="pl-1 cl-primary font-size-10 font-weight-bold my-auto">Ringkasan Transaksi</div>
                </div>
                <div class="px-3">
                  <v-card outlined class="mt-3 pa-3 elevation-0 rounded-xl">
                    <div class="d-flex flex-wrap">
                      <v-col cols="6" sm="6" class="py-0">
                        <div class="cl-dark-green font-size-10">Total Harga</div>
                      </v-col>
                      <v-col cols="6" sm="6" class="py-0 text-right">
                        <div class="cl-dark-green font-size-10 font-weight-bold">{{ sumTotal | toRupiah }}</div>
                      </v-col>
                      <v-col cols="6" sm="6" class="pb-0 pt-2">
                        <div class="cl-dark-green font-size-10">Total Berat</div>
                      </v-col>
                      <v-col cols="6" sm="6" class="pb-0 pt-2 text-right">
                        <div class="cl-dark-green font-size-10 font-weight-bold">{{ transactionDetail.transaction_total_weight | toKg }}</div>
                      </v-col>
                    </div>
                  </v-card>
                  <v-card outlined class="mt-2 pa-3 elevation-0 rounded-xl">
                    <div class="d-flex flex-wrap">
                      <v-col cols="12" sm="4" md="3" class="py-0 my-auto">
                        <div class="cl-dark-green font-size-10">Jasa Pengiriman</div>
                      </v-col>
                      <v-col cols="12" sm="4" md="5" class="py-sm-0 my-auto" v-if="transactionDetail.transaction_expedition_name">
                        <div class="cl-dark-green font-size-10">{{ transactionDetail.transaction_expedition_name }}</div>
                        <div class="cl-grey font-size-11">{{ transactionDetail.transaction_expedition_service }}</div>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="py-0 my-auto text-right">
                        <div class="cl-dark-green font-size-10 font-weight-bold">{{ transactionDetail.transaction_expedition_price | toRupiah }}</div>
                      </v-col>
                    </div>
                  </v-card>
                  <v-card outlined class="mt-2 pa-3 elevation-0 rounded-xl">
                    <div class="d-flex flex-wrap">
                      <v-col cols="12" sm="6" class="py-0">
                        <div class="cl-dark-green font-size-11 font-weight-bold">Total Pembayaran</div>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0 text-right">
                        <div class="cl-dark-green font-size-11 font-weight-bold">{{ transactionDetail.transaction_total_price | toRupiah }}</div>
                      </v-col>
                    </div>
                  </v-card>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </div>
      <template v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</template>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			loading: true,
      btn_disabled: true,
      btn_loading: false,
      image_upload: null,
			url_image: null,
      detail_type: '',
      detail_code: '',
      rules: {
				filebukti: [
					v => !!v || 'File bukti transfer tidak boleh kosong',
					v => (v && v.size > 0) || 'File bukti transfer tidak boleh kosong',
					v => (v && v.size < 3145728) || 'Ukuran file bukti transfer tidak boleh lebih dari 3 MB',
				],
			}
		}
	},
  props: {
  },
	computed: {
    ...mapState('transaksiProduk', ['transactionDetail']),

		sumTotal() {
			let total = 0
			this.transactionDetail.transaction_detail.forEach((el) => {
				total += (parseInt(el.transaction_detail_unit_price) + parseInt(el.transaction_detail_product_admin_charge_value) - parseInt(el.transaction_detail_product_discount_value)) * parseInt(el.transaction_detail_qty)
			})
			return total
		},
	},
	methods: {
    ...mapActions('transaksiProduk', ['getTransactionDetail']),

    goBack() {
      this.$router.push({ name: 'lap-pembelian-produk' })
    },
		previewImage(event) {
			if (event) {
				if (this.image_upload.size > 3145728) {
					this.errorValidation.transfer_image = 'Ukuran file bukti transfer tidak boleh lebih dari 3 MB'
					this.url_image = ''
					this.btn_disabled = true
				} else {
					this.url_image = URL.createObjectURL(this.image_upload)
					this.btn_disabled = false
					delete this.errorValidation.transfer_image
				}
			} else {
				this.url_image = null
				this.btn_disabled = true
				delete this.errorValidation.transfer_image
			}
		},
		handleFileUpload() {
			this.btn_loading = true
			let formData = new FormData()
			formData.append('transaction_code', this.detail_code)
			formData.append('transaction_bank_transfer_attachment', this.image_upload)

			this.uploadPayment(formData).then(() => {
        this.getNotificationTransaction()
        this.$router.push({ params: {type: 'detail', slug: this.detail_code} })
        this.detail_type = this.$route.params.type
        this.loading = true
        this.getTransactionDetail({ code: this.detail_code }).then(() => {
          this.loading = false
        })
				this.btn_loading = false
			}).catch(() => {
				this.btn_loading = false
			})
		},
	},
  async created() {
    this.detail_code = this.$route.params.code
    this.getTransactionDetail({ code: this.detail_code }).then(() => {
      this.loading = false
    })

		// const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		// const data = await JSON.parse(authData)

		// await this.$store.dispatch('setPageTitle', `Detail Pembelian Produk`)
		// this.loading = await true
		// await this.getTransactionDetail({ code: this.detail_code }).then(() => {
		// 	if (data.member_network_code !== this.transactionDetail.transaction_member_ref_network_code) {
		// 		this.$router.push({name: 'lap-pembelian-produk'})
		// 	} else {
		// 		this.loading = false
		// 	}
		// }).catch(() => {
		// 	this.loading = false
		// })
	}
};
</script>